(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/components/correction-mail.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/components/correction-mail.js');
'use strict';

const _svs$ui$reactForm = svs.ui.reactForm,
  Fieldset = _svs$ui$reactForm.Fieldset,
  Radio = _svs$ui$reactForm.Radio,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Checkbox = _svs$ui$reactForm.Checkbox;
const TopHeader = svs.myProfile.react.shared.components.TopHeader;
const _svs$myProfile$consta = svs.myProfile.constants,
  backendName = _svs$myProfile$consta.backendName,
  checkboxNotification = _svs$myProfile$consta.checkboxNotification,
  titles = _svs$myProfile$consta.titles,
  icons = _svs$myProfile$consta.icons;

const MAIL = [backendName.CORRECTION_MAIL_LOTTO, backendName.CORRECTION_MAIL_EUROJACKPOT, backendName.CORRECTION_MAIL_VIKING_LOTTO, backendName.CORRECTION_MAIL_KENO, backendName.WIN_RESULTS];

const MAIL_YES = {
  [backendName.CORRECTION_MAIL_LOTTO]: true,
  [backendName.CORRECTION_MAIL_EUROJACKPOT]: true,
  [backendName.CORRECTION_MAIL_VIKING_LOTTO]: true,
  [backendName.CORRECTION_MAIL_KENO]: true,
  [backendName.WIN_RESULTS]: true
};

const MAIL_NO = {
  [backendName.CORRECTION_MAIL_LOTTO]: false,
  [backendName.CORRECTION_MAIL_EUROJACKPOT]: false,
  [backendName.CORRECTION_MAIL_VIKING_LOTTO]: false,
  [backendName.CORRECTION_MAIL_KENO]: false,
  [backendName.WIN_RESULTS]: false
};

const ONLY_WIN_MAIL = {
  [backendName.CORRECTION_MAIL_LOTTO]: false,
  [backendName.CORRECTION_MAIL_EUROJACKPOT]: false,
  [backendName.CORRECTION_MAIL_VIKING_LOTTO]: false,
  [backendName.CORRECTION_MAIL_KENO]: false,
  [backendName.WIN_RESULTS]: true
};

const CorrectionMail = _ref => {
  let children = _ref.children,
    model = _ref.model,
    handleMultiCheckbox = _ref.handleMultiCheckbox;
  let isCheckedMail = false;
  let isCheckedWin = true;

  MAIL.forEach(id => {
    if (model[id]) {
      isCheckedMail = true;
      if (id !== backendName.WIN_RESULTS && model[id]) {
        isCheckedWin = false;
      }
    }
  });
  return React.createElement("div", null, React.createElement(TopHeader, {
    icon: icons.CORRECT,
    title: titles.CORRECT
  }), React.createElement("p", null, "Vi kan skicka p\xE5minnelser om hur det g\xE5r i nummerspel du spelar. Utskick kan inneh\xE5lla marknadsf\xF6ring."), React.createElement(Fieldset, {
    legend: titles.CORRECT,
    srOnly: true
  }, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(Checkbox, {
    checked: isCheckedMail,
    id: "gameNotification",
    onChange: () => {
      handleMultiCheckbox(isCheckedMail ? MAIL_NO : MAIL_YES, isCheckedMail, checkboxNotification.TRACK_MAIL);
    }
  }, "Skicka e-post n\xE4r nummerspelen har avgjorts")), React.createElement("div", {
    className: "margin-left-2"
  }, React.createElement(ControlGroup, null, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(Radio, {
    checked: !isCheckedWin,
    disabled: !isCheckedMail,
    onChange: () => {
      handleMultiCheckbox(MAIL_YES, !isCheckedWin, checkboxNotification.TRACK_LINK);
    },
    value: "correct"
  }, "Skicka l\xE4nk till r\xE4ttning")), React.createElement(Radio, {
    checked: isCheckedWin && isCheckedMail,
    disabled: !isCheckedMail,
    onChange: () => {
      handleMultiCheckbox(ONLY_WIN_MAIL, isCheckedWin, checkboxNotification.TRACK_WIN);
    },
    value: "win"
  }, "Skicka endast vinstmejl n\xE4r jag har vunnit"))), children));
};
svs.myProfile.react.pages.notifications.components.CorrectionMail = CorrectionMail;

 })(window);